export const environment = {
    useMockData: true,
    bffBaseUrl: 'http://localhost:7071',
}
